/* __next_internal_client_entry_do_not_use__ Switch auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Switch as ReactSwitch, withRouter } from "react-router-dom";
import { removeLocaleFromUrl } from "./util";
var SwitchBase = function(props) {
    var location = props.location, otherProps = _object_without_properties(props, [
        "location"
    ]);
    var newLocation = _object_spread_props(_object_spread({}, location), {
        pathname: removeLocaleFromUrl(location.pathname)
    });
    return /*#__PURE__*/ _jsx(ReactSwitch, _object_spread({
        location: newLocation
    }, otherProps));
};
export var Switch = withRouter(SwitchBase);
